import { getLanguageFromStorage } from 'syf-js-utilities';
import config from '../const/config';
/*
 * Default fallback config if not provided by channel app
 * Note: apigee and assets still needs to be updated when config is added
 */
export const coreFallbackConfig = {
    hosts: {
        apigee: new URL(config.API_HOST),
        assets: new URL(config.ASSETS_HOST)
    },
    apiErrorCallback: () => undefined,
    lang: getLanguageFromStorage()
};
